export default "__VITE_ASSET__DDSmzmJM__"